import { createSlice } from "@reduxjs/toolkit";


const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    profile_image:'',
    authenticated: false,
    selectedaccount: null,
    selectedasset: null,
    allbalance: null,
    riskbalance: null,
    calculationbalance: null,
    risk_Level1: '',
    risk_Level2: '',
    risk_Level3: '',
    cl_value: null,
    cl_status:null, // Initialize as empty array
    account_status:false,
    risk_Level_id:'',
    account_priority:''
  },
  
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.authenticated = true;
    },
    userlogout: (state,action) => {
      state.user = null;
      state.authenticated = false;
      state.selectedaccount=null;
      state.selectedasset=null;
      state.allbalance= null;
      state.riskbalance= null;
      state.calculationbalance=null;
      state.risk_Level1= null;
      state.risk_Level2= null;
      state.risk_Level3= null;
      state.cl_value= null;
      state.cl_status=null;
      state.account_status=false;
      state.profile_image='';
      state.risk_Level_id=''
     
    },
    submitRisk_level_id:(state,action)=>{
        state.risk_Level_id=action.payload;
    },
    ClearRisk_level_id:(state,action)=>{
      state.risk_Level_id='';
  },
    selectAccount: (state, action) => {
      state.selectedaccount = action.payload.account;
    },
    selectAsset: (state, action) => {
      state.selectedasset = action.payload.asset;
    },
    cancelAsset: (state, action) => {
      
      state.selectedasset = null;
    },
    cancelRiskLevelData:(state,action)=>{

      state.risk_Level1= null;
      state.risk_Level2= null;
      state.risk_Level3= null;
    },
    getBalance: (state, action) => {
      state.allbalance = action.payload;
    },
    getRiskBalance: (state, action) => {
      
      // state.riskbalance = action.payload.risk_balance;
    },
    getCalculationBalance: (state, action) => {
    
      state.calculationbalance = action.payload;
    },
    storeRiskLevel1: (state, action) => {
      
      state.risk_Level1 = action.payload;
    },
    storeRiskLevel2: (state, action) => {
      state.risk_Level2 = action.payload;
    },
    storeRiskLevel3: (state, action) => {
      state.risk_Level3 = action.payload;
    },
    setCl_value: (state, action) => {
      state.cl_value = action.payload;
    },
    addAssetItem: (state, action) => {
      
     state.cl_status=action.payload
    },
    addAccountStatus:(state,action)=>{
      state.account_status=action.payload;
    },
    addProfileImage:(state,action)=>{
      // state.profile_image=action.payload;
      const uniqueUrl = `${action.payload}?${new Date().getTime()}`;
      state.profile_image = uniqueUrl;
    },
    addAccountPriority:(state,action)=>{
      
      
      state.account_priority=action.payload;
    }
  },
});

export const {
  login,
  userlogout,
  selectAccount,
  selectAsset,
  getBalance,
  getRiskBalance,
  getCalculationBalance,
  storeRiskLevel1,
  storeRiskLevel2,
  storeRiskLevel3,
  setCl_value,
  addAssetItem,
  cancelAsset,
  addAccountStatus,
  addProfileImage,
  cancelRiskLevelData,
  submitRisk_level_id,
  ClearRisk_level_id,
  addAccountPriority
} = userSlice.actions;


export const UserDetails = (state) => state.user.user;
export const UserStatus = (state) => state.user.authenticated;
export const SelectedAccount = (state) => state.user.selectedaccount;
export const SelectedAsset = (state) => state.user.selectedasset;
export const Allbalance = (state) => state.user.allbalance;
export const RiskBalance = (state) => state.user.riskbalance;
export const CalculationBalance = (state) => state.user.calculationbalance;
export const Risk_Level1_Data = (state) => state.user.risk_Level1;
export const Risk_Level2_Data = (state) => state.user.risk_Level2;
export const Risk_Level3_Data = (state) => state.user.risk_Level3;
export const CL_value = (state) => state.user.cl_value;
export const Asset_Status = (state) => state.user.cl_status;
export const Account_Status=(state)=>state.user.account_status;
export const Profile_Image=(state)=>state.user.profile_image;
export const Get_RiskLevel_id=(state)=>state.user.risk_Level_id;
export const Account_Priority=(state)=>state.user.account_priority;

export default userSlice.reducer;
